const ripple = {
  mounted(el, binding) {
    let targetEl = typeof binding.value === 'undefined' ? el : el.querySelector(binding.value)
    if (targetEl !== el) el.classList.add('ripple-parent')

    targetEl.classList.add('ripple')
    el.addEventListener('click', (e) => {
      e = e.touches ? e.touches[0] : e
      const r = targetEl.getBoundingClientRect(),
        d = Math.sqrt(Math.pow(r.width, 2) + Math.pow(r.height, 2)) * 3
      targetEl.style.cssText = `--s: 0; --o: 1;`
      targetEl.offsetTop
      targetEl.style.cssText = `--t: 1; --o: 0; --d: ${d}; --x:${e.clientX - r.left}; --y:${e.clientY - r.top};`
    })
  }
}

export default ripple
